import { Component, OnDestroy } from '@angular/core';
import { CustomDurationPipe } from '@app/shared/pipes/custom-duration.pipe';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { GoogleTagManagerService } from '@app/core/lib/google-tag-manager/angular-google-tag-manager.service';
import moment, { Duration } from 'moment';
import { Constant } from 'src/constant';
import * as fromUploader from '../../../../store/reducers';
import { Observable, Subscription } from 'rxjs';
import { UploaderStatus } from '@smash-sdk/uploader';
import { PrepareActions, UploadActions } from '@app/client/uploader/store/actions';
@Component({
  selector: 'app-modal-size-premium',
  templateUrl: './modal-size-premium.component.html',
  styleUrls: ['./modal-size-premium.component.scss']
})
export class ModalSizePremiumComponent implements OnDestroy {
  status$: Observable<UploaderStatus>;

  currency: string = null;
  formatQueue: any;
  timer: Duration;
  timerFormat: string;
  interval: any;
  start: any;
  updatedTime: any;
  goPremium = false;
  subscriptions: Subscription[] = [];

  constructor(
    private store: Store<fromUploader.State>,
    public ref: DialogRef,
    private customDurationPipe: CustomDurationPipe,
    private translateService: TranslateService,
    private gtmService: GoogleTagManagerService,
  ) {
    this.status$ = this.store.select(fromUploader.getUploadStatus);

    this.timer = moment.duration(this.ref.data.queue, 'seconds');
    this.start = moment();
    this.interval = setInterval(() => {
      this.updatedTime = moment();
      const diff = this.updatedTime.diff(this.start);
      this.timer = moment.duration(this.ref.data.queue, 'seconds');
      this.timer = this.timer.subtract(Math.floor(diff / 1000), 'second');
      this.timerFormat = `${this.timer.hours() < 10 ? '0' + this.timer.hours() : this.timer.hours()}:${this.timer.minutes() < 10 ? '0' + this.timer.minutes() : this.timer.minutes()}:${this.timer.seconds() < 10 ? '0' + this.timer.seconds() : this.timer.seconds()}`;
      if (this.timer.asMilliseconds() <= 0) {
        this.clearTimer();
      }
    }, 1000);

    this.formatQueue = this.customDurationPipe.transform(ref.data.queue);
    this.currency = this.ref.data.countries.find((country: any) => country.countryCode === this.ref.data.countryCode).currency === 'eur' ? '€' : '$';
    this.subscriptions = [
      this.ref.backdropClick$.subscribe(() => {
        this.gtmService.pushTag({
          event: Constant.eventGTM.CLICK_BACKDROP_MODAL_SIZE_PREMIUM,
          transfer_size: ref.data.transferSize,
        });
        this.store.dispatch(PrepareActions.HideModalSizePremium());
      }),
    ];
  }

  ngOnDestroy(): void {
    this.clearTimer();
    this.subscriptions.map((subscription: Subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }

  clearTimer() {
    clearInterval(this.interval);
    this.timerFormat = null;
  }

  onUploadAnonymous() {
    this.store.dispatch(PrepareActions.HideModalSizePremium());
    this.store.dispatch(UploadActions.Upload());
    this.closeModal();
  }

  closeModal() {
    this.store.dispatch(PrepareActions.HideModalSizePremium());
    this.clearTimer();
    this.ref.close();
  }

  goSubscribe($event, URL) {
    this.goPremium = true;
    setTimeout(() => {
      window.open(this.translateService.instant(URL), '_blank');
    }, 1000);
    $event.preventDefault();
    $event.stopPropagation();
  }
}
